(function () {

  var FLEEN_DEPT = {
    "06": { slug: "nice",             label: "Nice (06)"             },
    "13": { slug: "marseille",        label: "Marseille (13)"        },
    "14": { slug: "caen",             label: "Caen (14)"             },
    "21": { slug: "dijon",            label: "Dijon (21)"            },
    "25": { slug: "besancon",         label: "Besançon (25)"         },
    "29": { slug: "brest",            label: "Brest (29)"            },
    "30": { slug: "nimes",            label: "Nîmes (30)"            },
    "31": { slug: "toulouse",         label: "Toulouse (31)"         },
    "33": { slug: "bordeaux",         label: "Bordeaux (33)"         },
    "34": { slug: "montpellier",      label: "Montpellier (34)"      },
    "35": { slug: "rennes",           label: "Rennes (35)"           },
    "37": { slug: "tours",            label: "Tours (37)"            },
    "38": { slug: "grenoble",         label: "Grenoble (38)"         },
    "42": { slug: "saint-etienne",    label: "Saint-Étienne (42)"    },
    "44": { slug: "nantes",           label: "Nantes (44)"           },
    "45": { slug: "orleans",          label: "Orléans (45)"          },
    "49": { slug: "angers",           label: "Angers (49)"           },
    "51": { slug: "reims",            label: "Reims (51)"            },
    "54": { slug: "nancy",            label: "Nancy (54)"            },
    "57": { slug: "metz",             label: "Metz (57)"             },
    "59": { slug: "lille",            label: "Lille (59)"            },
    "63": { slug: "clermont-ferrand", label: "Clermont-Ferrand (63)" },
    "66": { slug: "perpignan",        label: "Perpignan (66)"        },
    "67": { slug: "strasbourg",       label: "Strasbourg (67)"       },
    "68": { slug: "mulhouse",         label: "Mulhouse (68)"         },
    "69": { slug: "lyon",             label: "Lyon (69)"             },
    "72": { slug: "le-mans",          label: "Le Mans (72)"          },
    "74": { slug: "annecy",           label: "Annecy (74)"           },
    "75": { slug: "paris",            label: "Paris & Île-de-France" },
    "76": { slug: "rouen",            label: "Rouen (76)"            },
    "77": { slug: "paris",            label: "Paris & Île-de-France" },
    "78": { slug: "paris",            label: "Paris & Île-de-France" },
    "80": { slug: "amiens",           label: "Amiens (80)"           },
    "83": { slug: "toulon",           label: "Toulon (83)"           },
    "87": { slug: "limoges",          label: "Limoges (87)"          },
    "91": { slug: "paris",            label: "Paris & Île-de-France" },
    "92": { slug: "paris",            label: "Paris & Île-de-France" },
    "93": { slug: "paris",            label: "Paris & Île-de-France" },
    "94": { slug: "paris",            label: "Paris & Île-de-France" },
    "95": { slug: "paris",            label: "Paris & Île-de-France" }
  };

  window.fleenRouteCP = function () {
    var input  = document.getElementById("fleen-cp-input");
    var result = document.getElementById("fleen-cp-result");
    var cp     = (input.value || "").trim().replace(/\D/g, "");

    result.className = "fleen-cp-result";
    result.innerHTML = "";

    if (cp.length !== 5) {
      result.classList.add("error");
      result.textContent = "Veuillez saisir un code postal à 5 chiffres.";
      return;
    }

    var match = FLEEN_DEPT[cp.substring(0, 2)];

    if (match) {
      result.classList.add("success");
      result.innerHTML =
        "✅ Nous intervenons à <strong>" + match.label + "</strong> • " +
        "<a href=\"/pages/traitement-punaise-de-lit-" + match.slug + "\" " +
        "title=\"Traitement punaises de lit " + match.label + "\">" +
        "Prendre rendez-vous maintenant →</a>";
    } else {
      result.classList.add("error");
      result.innerHTML =
        "Votre secteur n'est pas encore couvert. " +
        "<a href=\"/pages/entreprise-traitement-punaise-de-lit\" " +
        "title=\"entreprise punaise de lit\">" +
        "Contactez-nous pour vérifier →</a>";
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    var input = document.getElementById("fleen-cp-input");
    if (!input) return;
    input.addEventListener("input", function () {
      this.value = this.value.replace(/\D/g, "").slice(0, 5);
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") window.fleenRouteCP();
    });
  });

})();